import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/servicespage.css';
import '../style/aboutuspage.css';
import { Typography } from '@mui/material';
import { FaCheckCircle } from "react-icons/fa";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Footer from '../components/Footer';
import Servicecard from '../components/Servicescard'
import Infokontakt from './Infokontakt';

function Aboutuspage() {
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
   
  }, []);
  const navigate = useNavigate();
  
const handleClick = () => {
  navigate('/kontakt');
};


  return (
  
    <div className='about-us-container-page'>
      <div className="about-container-background">
          <Typography variant='h3'
          sx={{
            color:'var(--secondaryColor)',
            fontFamily:'Rubik',
            fontSize:'50px',
            fontWeight:'bold',
            marginLeft:'50px'
          }}
          >Über uns</Typography>
      </div>
      <div className="content-text-about-us" data-aos="zoom-in"
            data-aos-offest='200'
            data-aos-duration='1000'
              data-aos-once="true">
          <div className="photo-aboutus">
            <div className="photo-image">
            </div>
          </div>
          <div className="text-about-us-now">
            <div className="text-for-about-us">
              {/* <Typography variant='body2'
              sx={{
                fontFamily:'Rubik',
                fontWeight:'Regular',
                textAlign:'center'
              }}
              gutterBottom>Herzlich willkommen bei Service Cleaning</Typography> */}
              <Typography variant='h3' sx={{
                fontFamily:'Rubik',
                fontSize:'30px',
                textAlign:'center',
                fontWeight:'500'

              }} gutterBottom>Wir lassen Räume glänzen. Sie genießen den Unterschied.</Typography>
              <Typography variant='bod2' sx={{
                fontFamily:'Rubik',
                fontSize:'14px'
              }} gutterBottom>
               Sauberkeit ist für uns mehr als nur ein Service – sie ist unser Anspruch. Mit höchsten Qualitätsstandards, geschulten Fachkräften und viel Liebe zum Detail sorgen wir für ein gepflegtes, gesundes und repräsentatives Umfeld.<br/>
                <br />Ihre Zufriedenheit steht bei uns an erster Stelle. Deshalb arbeiten wir zuverlässig, präzise und individuell auf Ihre Anforderungen abgestimmt – erst wenn Sie begeistert sind, sind wir es auch.
                <br />
                <br />Dafür stehen wir:
              </Typography>
              <div className="text-tick">
                <Typography sx={{ display: "flex", alignItems: "center", fontFamily:'Rubik' }}><FaCheckCircle className="checkicon"  style={{ marginRight: "10px" }} /> Hochbewertete Reinigungsleistungen.</Typography>
                <Typography sx={{ display: "flex", alignItems: "center",marginRight:"20px" }}  ><FaCheckCircle className="checkicon"  style={{ marginRight: "10px" }}/> Professionelle Wohnungs- & Gewerbereinigung.</Typography>
                <Typography sx={{ display: "flex", alignItems: "center" }}><FaCheckCircle className="checkicon"  style={{ marginRight: "10px" }}/> Maßgeschneiderte Reinigungslösungen</Typography>
                
              </div>
              <br />
              <Typography variant='bod2' sx={{
                fontFamily:'Rubik',
                fontSize:'14px',
                paddingTop:'20px',
              }} gutterBottom>
               Unser erfahrenes Team steht für Qualität, Vertrauen und Perfektion bis ins kleinste Detail.
               <br/>
               <br/>
               Erleben Sie Reinigung auf einem neuen Niveau.
Kontaktieren Sie uns – wir beraten Sie gerne persönlich.
              </Typography>
              <div className="button-kontakt">
                <Stack>
             <Button variant='contained' onClick={handleClick} fullWidth className='Kontaktanfrage-absenden' 
             sx={{
                width:{
                    xs: 100,
                    sm: 200,
                    md: 300,
                    lg: 400,
                    xl: 500
                },
                backgroundColor:'#01B8B0',

                fontSize:'20px',
                marginTop:'20px',
                marginBottom:'20px',
                '&:hover': {
                  backgroundColor:'#01b8c3'
                }

        }}>Beratungstermin vereinbaren</Button>
            </Stack>
                
              </div>
            </div>
          </div>
      </div>
      <div className='ourService-about'>
      <div className="first-text-of-content-services">
          <Typography variant="h6"  sx={{  alignItems: "center", fontFamily:'Rubik', color:'var(--textColor)', fontWeight:'normalf' }}><span className="right-line"></span> Unsere Dienstleistungen <span className="left-line"></span></Typography>
      
        </div>

      <Servicecard />
      </div>
     <Infokontakt />
     <Footer />
    </div>
  )
}

export default Aboutuspage
